export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    // visible: !disabled,
  },

  {
    title: that.$l('table_label_batchNo') || '缸批号',
    field: 'batchNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_colorGrade') || '颜色等级',
    field: 'v_colorGrade',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_measuredWidth') || '实测门幅(CM)',
    field: 'measuredWidth',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_actualGSM') || '实测克重(gsm)',
    field: 'actualGSM',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_inspectQuantity') || '检验米数(M)',
    field: 'inspectQuantity',
    headerAlign: 'center',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_actualQuantity') || '实测米数(M)',
    field: 'actualQuantity',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_qualifiedQuantity') || '合格米数(M)',
    field: 'qualifiedQuantity',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_defectiveQuantity') || '不良米数(M)',
    field: 'defectiveQuantity',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_defectTotalCount') || '疵点总计',
    field: 'defectTotalCount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_utilizationRate') || '利用率',
    field: 'utilizationRate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
    formatter: ({ cellValue }) => {
      return cellValue ? [cellValue, '%'].filter(Boolean).join('') : '0%'
    },
  },
  {
    title: that.$l('table_label_finalResult') || '判定结果',
    field: 'v_finalResult',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_shortQuantity') || '短码数量(M)',
    field: 'shortQuantity',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_shortRate') || '短码率',
    field: 'shortRate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    isTotalColumn: true,
    formatter: ({ cellValue }) => {
      return cellValue ? [cellValue, '%'].filter(Boolean).join('') : '0%'
    },
  },
  {
    title: that.$l('table_label_kValue') || 'K值',
    field: 'kvalue',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => cellValue || '0',
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('table_label_costFactor') || '质量成本系数',
  //   field: 'costFactor',
  //   headerAlign: 'center',
  //   align: 'center',
  //   minWidth: 130,
  //   showHeaderOverflow: true,
  //   showOverflow: false,
  //   isTotalColumn: true,
  // },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 130,
    showHeaderOverflow: true,
    // visible: !disabled,
    slots: { default: 'opt' },
  },
]
